import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  loaderText$ = new BehaviorSubject<string>('');
  showLoader$: Observable<boolean>;

  private numberOfLoadersOpen$ = new BehaviorSubject<number>(0);

  constructor() {
    this.showLoader$ = this.numberOfLoadersOpen$.pipe(map((n) => n > 0));
  }

  show(loaderText?: string): void {
    this.loaderText$.next(loaderText ?? '');
    this.numberOfLoadersOpen$.next(this.numberOfLoadersOpen$.getValue() + 1);
  }

  hide(): void {
    const numberOfLoadersOpen = this.numberOfLoadersOpen$.getValue();

    if (numberOfLoadersOpen > 0) {
      this.numberOfLoadersOpen$.next(numberOfLoadersOpen - 1);
    }
  }
}
